<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            v-if="formParam.header.id!='' && formParam.header.id!=null"
          >Edit WA Rotator</h5>
          <h5 class="modal-title" v-else>Tambah WA Rotator</h5>
          <!-- {{formParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="tab-content">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>
                        Title:
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        v-if="formParam.header.id==''"
                        v-model="formParam.header.title"
                        placeholder
                        type="text"
                        class="form-control"
                        @change="generateSlugLinkGenerator"
                      />
                      <input
                        v-else
                        v-model="formParam.header.title"
                        placeholder
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <label>
                            Domain:
                            <span class="text-danger">*</span>
                          </label>
                          <select v-model="formParam.header.domain" class="form-control">
                            <option :value="''">Select</option>
                            <template v-for="domainName in domainRows">
                              <option :value="domainName" :key="domainName">{{domainName}}</option>
                            </template>
                          </select>
                        </div>
                        <div class="col-md-6">
                          <label>
                            Slug:
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            v-model="formParam.header.slug"
                            placeholder
                            type="text"
                            class="form-control"
                            @change="checkSlugLinkGenerator"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>
                        Operators:
                        <span class="text-danger">*</span>
                      </label>
                      <div class="text-muted">
                        - Semakin kecil nilai
                        <b>Priority</b> yang diinput, maka operator akan semakin diprioritaskan.
                        <br />- Jika
                        <b>Weight</b> diisi > 1, maka operator tersebut akan dipanggil sebanyak x
                        <b>Weight</b>,
                        lalu akan diganti ke operator berikutnya jika telah terpenuhi.
                        <br />-
                        <b>Priority</b> &amp;
                        <b>Weight</b> hanya berlaku untuk
                        <i>Rotation Type: Sequential</i>.
                        <br />
                        <span class="text-info">
                          Tips: Set semakin kecil
                          <b>Priority</b> &amp; semakin besar
                          <b>Weight</b> untuk operator terbaik kamu.
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="row"
                        v-for="(rowSome,indxSome) in formParam.detail"
                        :key="indxSome"
                      >
                        <div class="col-md-7">
                          <div class="form-group form-focus select-focus">
                            <label>Operator</label>
                            <select
                              v-model="formParam.detail[indxSome].operator_id"
                              style="width:100%"
                            >
                              <option :value="''">Select</option>
                              <template v-for="(row,idx) in operatorRows">
                                <option
                                  :value="row.id"
                                  :key="idx"
                                >{{row.public_name}} - {{row.phone_number}}</option>
                              </template>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <label>Priority</label>
                          <input
                            v-model="formParam.detail[indxSome].operator_priority"
                            placeholder="Priority"
                            type="number"
                            style="width:100%"
                          />
                        </div>
                        <div class="col-md-2">
                          <label>Weight</label>
                          <!-- <input
                            v-model="formParam.detail[indxSome].operator_weight"
                            placeholder="Weight"
                            type="number"
                            style="width:100%"
                          /> -->
                          <select
                            v-model="formParam.detail[indxSome].operator_weight"
                            style="width:100%"
                          >
                            <template v-for="valueWeight in 30">
                              <option :value="valueWeight" :key="valueWeight">{{valueWeight}}</option>
                            </template>
                          </select>
                        </div>
                        <div class="col-md-1">
                          <a
                            v-if="indxSome==0 && formParam.detail.length==1"
                            @click.prevent="addRow"
                          >
                            <i class="fa fa-plus"></i>
                          </a>
                          <template v-else-if="indxSome>0 && indxSome==(formParam.detail.length-1)">
                            <a @click.prevent="addRow">
                              <i class="fa fa-plus"></i>
                            </a>
                            <a @click.prevent="removeRow(indxSome,(formParam.detail.length-1))">
                              <i class="fa fa-minus"></i>
                            </a>
                          </template>
                          <a
                            v-else
                            @click.prevent="removeRow(indxSome,(formParam.detail.length-1))"
                          >
                            <i class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-sm-12 col-md-12">
                            <div class="form-group">
                              <label>
                                Chat Content:
                                <span class="text-danger">*</span>
                              </label>
                              <!-- {{broadcastParam}} -->
                              <div class="message-bar">
                                <div class="message-inner">
                                  <a class="link attach-icon" @click.prevent="emojiToggle()">
                                    <img style="width:30px;" src="@/assets/emoji.png" alt />
                                  </a>
                                  <div class="input-group m-b-30">
                                    <div class="input-group-append">
                                      <Emoji
                                        :open="emojiAttr.open"
                                        :width="emojiAttr.width"
                                        :height="emojiAttr.height"
                                        searchLabel="Search emoji here"
                                        @click="selectedEmoji"
                                      />
                                    </div>
                                    <textarea
                                      :style="'height:220px; z-index: 950;'"
                                      ref="messagebox"
                                      class="form-control"
                                      v-model="formParam.header.chat_content"
                                      :placeholder="'Type message...'"
                                      required
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <label>Loading Page:</label>
                          <div class="onoffswitch">
                            <input
                              type="checkbox"
                              name="onoffswitch"
                              v-model="formParam.header.is_loading_page"
                              class="onoffswitch-checkbox"
                              id="is_loading_page"
                            />
                            <label class="onoffswitch-label" for="is_loading_page">
                              <span class="onoffswitch-inner"></span>
                              <span class="onoffswitch-switch"></span>
                            </label>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <label>
                            Rotation Type:
                            <span class="text-danger">*</span>
                          </label>
                          <select v-model="formParam.header.rotation_type" class="form-control">
                            <option :value="''">Select</option>
                            <template v-for="(row,idx) in rotationTypeRows">
                              <option :key="idx" :value="row.id">{{row.label}}</option>
                            </template>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="submit-section">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending==false">
                    <!-- {{isSending}} -->
                    <button @click="saveForm(0,1)" class="btn btn-md btn-warning" type="button">
                      <i class="fa fa-save"></i> Draft
                    </button>

                    <button
                      @click.prevent="saveForm(0,0)"
                      class="btn btn-md btn-success"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-check"></i> Publish
                    </button>
                  </center>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending==false">
                    <button
                      @click.prevent="saveForm(1,0)"
                      class="btn btn-lg btn-info"
                      type="button"
                    >
                      <i class="fa fa-check"></i> Publish &amp; Exit
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    Emoji: VueChatEmoji,
    Datetime
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      generateSlugLoading: false,
      checkSlugLoading: false,
      domainLoading: false,
      operatorParams: {
        columnFilters: {
          keywords: "",
          is_publish: "publish"
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      rotationTypeLoading: false,
      rotationTypeRows: [],
      domainRows: [],
      operatorRows: [],
      operatorLoading: false,
      selectedLicense: [],
      licenseOptions: [],
      licenseListParam: {
        id: "",
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoadingLicense: false,
      emojiAttr2: {
        open: false,
        width: "0%",
        height: "0px"
      },
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}"
      ],
      isSending: false,
      formParam: {
        header: {
          id: "",
          title: "",
          domain: "",
          slug: "",
          fb_pixel_id: "",
          fb_pixel_event: "PageViews",
          fb_pixel_currency: "IDR",
          fb_pixel_amount: 0,
          g_tag_id: "",
          chat_content: "",
          is_loading_page: 0,
          rotation_type: "sequential",
          is_publish: 0
        },
        detail: [
          {
            operator_id: "",
            operator_priority: 0,
            operator_weight: 1
          }
        ]
      },
      isLoading: false
    };
  },
  watch: {
    isShowForm: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          this.domainRows = [];
          var that = this;
          // console.log("that.formParamSRSt",that.formParamSRSt)
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamLinkGeneratorSt.header.id != "" &&
              that.formParamLinkGeneratorSt.header.id != null
            ) {
              if (
                typeof that.formParamLinkGeneratorSt.header.copy !=
                  "undefined" &&
                that.formParamLinkGeneratorSt.header.copy == true
              ) {
                that.formParamLinkGeneratorSt.header.id = "";
              }

              // console.log("that.formParamSRSt", that.formParamSRSt);
              that.formParam = that.formParamLinkGeneratorSt;

              // that.uploadMessageType = "text";
              // if (that.formParam.header.message_type != "text") {
              //   that.formParam.header.is_enable_attach_file = true;
              //   that.uploadMessageType = that.formParam.header.message_type;
              // }
              // else {
              //   that.formParam.header.is_enable_attach_file = false;

              // }

              if (that.formParam.detail.length == 0) {
                {
                  that.formParam.detail.push({
                    operator_id: "",
                    priority: ""
                  });
                }
              }

              that.loadRotationType();
              that.loadDomain();
              that.loadOperator();
              console.log("that.formParam", that.formParam);
            } else {
              that.loadRotationType();
              that.loadDomain();
              that.loadOperator();
              that.formParam = {
                header: {
                  id: "",
                  title: "",
                  domain: "",
                  slug: "",
                  fb_pixel_id: "",
                  fb_pixel_event: "PageViews",
                  fb_pixel_currency: "IDR",
                  fb_pixel_amount: 0,
                  g_tag_id: "",
                  chat_content: "",
                  is_loading_page: 0,
                  rotation_type: "sequential",
                  is_publish: 0
                },
                detail: [
                  {
                    operator_id: "",
                    operator_priority: 0,
                    operator_weight: 1
                  }
                ]
              };
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken()
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
    ...mapGetters(["agentSession"]),
    formParamLinkGeneratorSt() {
      return this.$store.state.toolkit.formParamLinkGeneratorSt;
    },
    isShowForm() {
      return this.$store.state.toolkit.isShowForm;
    }
  },
  methods: {
    settabMessage(value) {
      this.tabMessage = value;
    },
    addRow() {
      let newRow = {
        operator_id: "",
        operator_priority: 0,
        operator_weight: 1
      };
      this.formParam.detail.push(newRow);
    },
    removeRow(removeIndex, maxIndex) {
      // console.log("removeIndex", removeIndex, maxIndex);
      if (removeIndex == 0 && maxIndex == 0) {
        return;
      }

      if (removeIndex > -1) {
        // only splice array when item is found
        this.formParam.detail.splice(removeIndex, 1); // 2nd parameter means remove one item only
      }
    },
    async loadRotationType() {
      this.rotationTypeLoading = await true;
      await this.$store
        .dispatch("toolkit/listRotationType") // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.rotationTypeRows = data;
          this.rotationTypeLoading = false;
        })
        .catch(error => {
          this.rotationTypeLoading = false;
          console.log(error);
        });
    },
    async loadDomain() {
      this.domainLoading = await true;
      await this.$store
        .dispatch("toolkit/listDomainLinkGenerator") // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.domainRows = data;
          this.domainLoading = false;
        })
        .catch(error => {
          this.domainLoading = false;
          console.log(error);
        });
    },
    async checkSlugLinkGenerator() {
      this.checkSlugLoading = await true;
      let param = {
        header: {
          id: this.formParam.header.id,
          slug: this.formParam.header.slug
        }
      };
      await this.$store
        .dispatch("toolkit/checkSlugLinkGenerator", param) // sesuai kan dengan method di API
        .then(response => {
          this.formParam.header.slug = response.data;
          this.checkSlugLoading = false;
        })
        .catch(error => {
          this.checkSlugLoading = false;
          console.log(error);
        });
    },
    async generateSlugLinkGenerator() {
      this.generateSlugLoading = await true;
      let param = {
        header: {
          id: this.formParam.header.id,
          title: this.formParam.header.title
        }
      };
      await this.$store
        .dispatch("toolkit/generateSlugLinkGenerator", param) // sesuai kan dengan method di API
        .then(response => {
          this.formParam.header.slug = response.data;
          this.generateSlugLoading = false;
        })
        .catch(error => {
          this.generateSlugLoading = false;
          console.log(error);
        });
    },
    async loadOperator() {
      this.operatorLoading = await true;
      this.operatorParams.page = 0;
      await this.$store
        .dispatch("toolkit/listOperator", this.operatorParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.operatorRows = data.data;
          this.operatorLoading = false;
        })
        .catch(error => {
          this.operatorLoading = false;
          console.log(error);
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabelLicense({ license_name, license_phone_number }) {
      if (typeof license_name != "undefined") {
        return `${license_name} – ${license_phone_number}`;
      }
    },
    asyncFindLicenseSelect(query) {
      this.licenseOptions = [];
      this.licenseListParam.license_name = query;
      this.licenseListParam.id = "";
      this.$store
        .dispatch("license/getLicenseList", this.licenseListParam)
        .then(response => {
          // this.isLoadingLicense = false;
          this.licenseOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          // this.isLoadingLicense = false;
        });
    },
    asyncFindLicense(query, id) {
      this.licenseListParam.license_name = query;
      if (typeof id != "undefined" && id != "") {
        this.licenseListParam.id = id;
      } else {
        this.licenseListParam.id = "";
      }
      this.$store
        .dispatch("license/getLicenseList", this.licenseListParam)
        .then(response => {
          this.isLoadingLicense = false;
          this.licenseOptions = response.data.data;
          // console.log("licenseOptions", this.licenseOptions);
          if (
            typeof id != "undefined" &&
            id != "" &&
            this.licenseOptions.length > 0
          ) {
            this.selectedLicense = this.licenseOptions;
          }
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoadingLicense = false;
        });
    },
    clearAllLicense() {
      this.selectedLicense = [];
    },
    addTemplateToMesage(template) {
      this.formParam.header.message += template;
    },
    addTemplateToMesage2(template) {
      this.formParam.header.message_away += template;
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    async saveForm(isExit = 0, isDraft = 0) {
      this.formParam.header.is_loading_page = this.formParam.header
        .is_loading_page
        ? 1
        : 0;

      if (typeof isDraft == "undefined") {
        this.formParam.header.is_publish = 1;
      } else {
        if (isDraft == 1) {
          this.formParam.header.is_publish = 0;
        } else {
          this.formParam.header.is_publish = 1;
        }
      }

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          this.emojiToggle(false);
          this.formParam.header.is_weight = parseFloat(0);
          this.formParam.header.num_clicks = parseFloat(
            this.formParam.header.num_clicks
          );
          this.formParam.header.num_operator = parseFloat(
            this.formParam.header.num_operator
          );
          this.formParam.header.fb_pixel_amount = parseFloat(
            this.formParam.header.fb_pixel_amount
          );
          this.formParam.header.create_datetime = new Date();
          this.formParam.header.update_datetime = new Date();
          this.formParam.header.member_id = parseInt(
            this.formParam.header.member_id
          );

          if (this.formParam.header.chat_content != "") {
            this.formParam.header.chat_content = await this.remove_tags(
              this.formParam.header.chat_content
            );
          }

          this.formParam.detail.forEach((row, idx) => {
            this.formParam.detail[idx]["operator_id"] = row.operator_id;
            this.formParam.detail[idx]["operator_priority"] = parseInt(
              row.operator_priority
            );
            this.formParam.detail[idx]["operator_weight"] = parseInt(
              row.operator_weight
            );
          });
          await this.$store
            .dispatch("toolkit/storeLinkGenerator", this.formParam)
            .then(response => {
              // this.isSending = false;
              if (this.formParam.header.id == "") {
                this.formParam = {
                  header: {
                    id: "",
                    title: "",
                    domain: "",
                    slug: "",
                    fb_pixel_id: "",
                    fb_pixel_event: "PageViews",
                    fb_pixel_currency: "IDR",
                    fb_pixel_amount: 0,
                    g_tag_id: "",
                    chat_content: "",
                    is_loading_page: 0,
                    rotation_type: "sequential",
                    is_publish: 0
                  },
                  detail: [
                    {
                      operator_id: "",
                      operator_priority: 0,
                      operator_weight: 1
                    }
                  ]
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.searchData();
              if (isExit == 1) {
                var elem = this.$refs.dismisModal;
                elem.click();
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.formParam.header.message += args.emoji;
      // console.log(args); /* return {...}*/
    },
    emojiToggle2(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr2.open == true) {
          this.emojiAttr2.open = false;
        } else {
          this.emojiAttr2.open = true;
        }
      } else {
        this.emojiAttr2.open = isClosed;
      }

      if (this.emojiAttr2.open == true) {
        this.emojiAttr2.width = "96%";
        this.emojiAttr2.height = "250px";
      } else {
        this.emojiAttr2.width = "0%";
        this.emojiAttr2.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji2(args) {
      this.formParam.header.message_away += args.emoji;
      // console.log(args); /* return {...}*/
    },

    updateMessageSupportCurrent(msgType) {
      this.uploadMessageSupportSelected = msgType;
    },
    updateMessageTypeCurrent(msgType) {
      if (msgType == "") {
        var that = this;
        setTimeout(function() {
          // console.log(
          //   "that.formParam.header.is_enable_attach_file",
          //   that.formParam.header.is_enable_attach_file
          // );
          if (that.formParam.header.is_enable_attach_file == true) {
            that.formParam.header.message_type = "image";
            that.uploadMessageType = that.formParam.header.message_type;
            // that.formParam.header.is_custom_url = false;
            // console.log("that.uploadMessageTyp",that.uploadMessageType)
          } else {
            that.formParam.header.message_type = "text";
          }
        }, 100);
      } else {
        this.uploadMessageType = msgType;
        this.formParam.header.message_type = msgType;
      }
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        // var liContainer = document.getElementById("drag_files");
        // var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal",isShowModal)
        // if (isShowModal == false) {
        //   // document.getElementById("btnDragFiles").click(); // Click on the checkbox
        // }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        console.log("oldddd", oldFile);
        console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          console.log("err", newFile.error.response);
          console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000
          }).then(r => {});
        }
        if (newFile.success && !oldFile.success) {
          this.formParam.header.image_url = newFile.response.data.url;
          this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.formParam.header.image_url = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/toolkit/linkGenerator/form.vue